import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DialogInterface} from './dialog.interface';
import {DateHelper} from '../../helpers/date.helper';

@Component({
  selector: 'app-dialog-scroll',
  templateUrl: 'dialog-scroll.component.html'
})
export class DialogScrollComponent implements OnInit{
  public dialogData: DialogInterface;
  public date = DateHelper;
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogInterface) { }

  ngOnInit(): void {
    this.dialogData = this.data;
  }
}
